<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Portal Slider</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link :href="`/admin/portal/slider`">Portal Slider</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Portal Slider</h4>
                  <p class="card-title-desc mb-0"><i>Content Management System</i> terkait gambar slide show pada halaman awal web.</p>
                </div>
                <div>
                  <!-- <button type="button" class="btn btn-success" @click="form.show = true">Tambah Baru</button> -->
                </div>
              </div>

              <hr>

              <div class="row">
                <div class="col-md-7">
                  <div class="card border" v-for="(row, i) in slider" :class="{ 'shadow-lg': row.is_published == 'Y', 'bg-light': row.is_published == 'T' }" :key="`slider-${i}`" @click="use(row)">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-auto">
                          <a class="cp text-muted" @click.stop>
                            <Icon :icon="['fa', 'ellipsis-v']" style="padding: 0 .1em;" />
                            <Icon :icon="['fa', 'ellipsis-v']" style="padding: 0 .1em;" />
                          </a>
                        </div>
                        <div class="col">
                          <h6 v-text="row.title"></h6>
                          <p class="text-muted m-0" v-text="row.subtitle"></p>
                        </div>
                        <div class="col-auto">
                          <img :src="'/' + row.imgpath" alt="Slider" style="height: 100%;position: absolute;right: 1em;">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-5">
                  <form action="" method="post" @submit.prevent="action">
                    <div class="mb-3">
                      <label for="formFile" class="form-label">Gambar</label>
                      <input class="form-control" type="file" id="formFile" @input="form.gambar = $event.target.files[0]" accept="image/*">
                    </div>
                    <div class="mb-3">
                      <label for="title" class="form-label">Judul</label>
                      <textarea v-model="form.title" id="title" rows="2" class="form-control"></textarea>
                    </div>
                    <div class="mb-3">
                      <label for="subtitle" class="form-label">Deskripsi</label>
                      <textarea v-model="form.subtitle" id="subtitle" rows="2" class="form-control"></textarea>
                    </div>
                    <div class="mb-3">
                      <label for="url" class="form-label">Url</label>
                      <input v-model="form.url" id="url" rows="2" class="form-control">
                    </div>
                    <div class="mb-3 form-check">
                      <input v-model="form.is_published" type="checkbox" class="form-check-input" id="publish">
                      <label class="form-check-label" for="publish">Publikasi</label>
                    </div>
                    <div class="mb-3">
                      <p class="m-0 text-muted">*Kosongi Gambar jika tidak ingin melakukan perubahan.</p>
                    </div>
                    <div>
                      <button type="submit" class="btn btn-success px-4 me-2">Simpan</button>
                      <button type="button" class="btn btn-danger px-4" @click="remove(form.id)" v-if="form.id">Hapus</button>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Modal },
  props: {
    slider: Array
  },
  data() {
    return {
      form: {
        id: false,
        title: '',
        subtitle: '',
        gambar: null,
        url: '',
        imgpath: '',
        is_published: false
      }
    }
  },
  methods: {
    use(row) {
      const {
        id,
        title,
        subtitle,
        is_published,
        imgpath,
        url
      } = row;

      this.form.id = id;
      this.form.title = title;
      this.form.subtitle = subtitle;
      this.form.imgpath = imgpath;
      this.form.url = url;
      this.form.is_published = is_published == 'Y';
    },
    inertiaConfig() {
      const config = {
        onSuccess: (res) => {
          this.form.id = false;
          this.form.title = '';
          this.form.subtitle = '';
          this.form.gambar = null;
          this.form.url = '';
          this.form.imgpath = '';
          this.form.is_published = false;
        }
      };
      return config;
    },
    action() {
      if(this.form.id) {
        this.$inertia.put('/admin/portal/slider/' + this.form.id, this.form, this.inertiaConfig());
      } else {
        this.$inertia.post('/admin/portal/slider', this.form, this.inertiaConfig());
      }
    },
    remove(id) {
      if(confirm('yakin hapus?'))
        this.$inertia.delete('/admin/portal/slider/' + id, this.inertiaConfig());
    }
  },
}
</script>
